<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

    <v-container v-if="!$store.getters.selected.length" justify-center>
        <v-layout text-xs-center row wrap>
            <v-flex>
                <v-card>
                    <v-card-text class="red--text px-0 justify-center">Δεν Υπάρχουν διαθέσιμα Διασυνδεδεμένα Τμήματα</v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

    <v-container v-else>


        <v-layout align-start fill-height justify-space-between row>
            <div></div>
            <div class="text-xs-center pt-2">

            </div>
            <v-tooltip top>
                <v-btn @click.native="createFinalObject"
                        class="mr-5"
                        color="info"
                        round
                        slot="activator">
                    <span class="editButton">Συνέχεια</span>
                    <v-icon>keyboard_arrow_right</v-icon>
                </v-btn>
                <span>Πατήστε "Συνέχεια" για να δείτε τα στοιχεία που έχετε καταχωρίσει και να ολοκληρώσετε τη δήλωσή σας</span>
            </v-tooltip>
        </v-layout>

        <hr/>

        <v-layout row>
            <v-expansion-panel popout>
                <v-expansion-panel-content @click.native="createLinkedDepartmentRequest(item.secretariatId, i)"
                        class="elevation-1"
                        :key="i"
                        v-for="(item, i) in $store.getters.selected">
                    <div slot="header">
                        <v-icon left>location_city</v-icon>
                        {{item.department}}
                    <!--<div @click="createLinkedDepartmentRequest(item.secretariatId, i)" slot="header">-->
                        <!--<v-card class="" flat-->
                                <!--ripple>-->
                            <!--<v-list :key="i">-->
                                <!--<v-list-tile>-->
                                    <!--<v-list-tile-action>-->

                                    <!--</v-list-tile-action>-->
                                    <!--<v-list-tile-avatar>-->
                                        <!--<v-icon left>location_city</v-icon>-->
                                    <!--</v-list-tile-avatar>-->

                                    <!--<v-list-tile-content>-->
                                        <!--<v-list-tile-title>-->
                                            <!--<span class="text&#45;&#45;primary">-->
                                        <!--{{item.department}}-->
                                    <!--</span>-->


                                        <!--</v-list-tile-title>-->
                                        <!--<v-list-tile-sub-title class="text-truncate caption">-->

                                        <!--</v-list-tile-sub-title>-->
                                    <!--</v-list-tile-content>-->
                                <!--</v-list-tile>-->
                            <!--</v-list>-->
                        <!--</v-card>-->
                    </div>


                    <v-layout row>
                        <v-expansion-panel popout @expand="onClickPanel($event, n)">
                            <v-expansion-panel-content
                                    ripple
                                    class="elevation-1"
                                    v-for="(semester, n) in $store.getters.linkedSemesterData[item.secretariatId]"
                                    @input="onInput($event, n)" @focus="$emit($event, n)"
                                    :value="n==currSection" :key="`expansion-${n}`">

                                <div slot="header" v-if="semester.semester == 0">
                                    Χωρίς Εξάμηνο
                                </div>

                                <div slot="header" v-else>
                                    {{semester.semester}}o Εξάμηνο
                                </div>

                                <LinkedTestComponent :dynamicKey="componentKey" :semester="semester.semester" :semesterInfo="semester.semesterInfo"
                                                     @addToArray="addToArray" @removeToArray="removeToArray"/>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                    </v-layout>


                    <v-layout  class="justify-center red--text mb-2">
                        {{$store.getters.selected[i].message}}
                    </v-layout>



                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-layout>
    </v-container>
</template>

<script>

    import utils from "../../utilities"
    import request from "../../requests"
    import TestComponent from "../TestComponents/testComponent";
    import requests from "../../requests";
    import LinkedTestComponent from "../TestComponents/LinkedTestComponent";

    export default {
        name: "LinkedDepartmentsComponent",
        components: {LinkedTestComponent, TestComponent},
        data() {
            return {
                checkedBooks: this.$store.getters.checkedBooks,
                message: '',
                utils,
                coursesArrayId: [],
                dialog: false,
                courses: [],
                semesters: [],
                listOfBooks: [],
                semesterCoursesArray: [],
                selectedSecretariatId: [],
                secretariatId: '',
                componentKey: 0,
                currSection: -1,
                openSection: true,
            }
        },
        methods: {

            onClickPanel(ev, n) {
                // console.log("Section click:", n + 1, ev);
                // this.componentKey += 1;
            },
            //on click event on the expansion panel re render the test component
            // with pass a dynamic key to component
            onInput (isOpen, n) {
                if (this.currSection == -1) {
                    this.currSection = n;
                }
                else if (n != this.currSection){
                    this.currSection = n;
                    this.componentKey += 1;
                }
            },

            createLinkedDepartmentRequest(secretariatId, i) {
                this.message = this.$store.getters.selected[i].message;
                if (this.$store.getters.linkedSemesterData[secretariatId] != null || this.$store.getters.selected[i].message !== '' )
                    return;

                this.secretariatId = secretariatId;
                this.$store.commit('setLoadingModal', true);
                this.selectedSecretariatId = secretariatId;

                requests.allCourses(secretariatId, this.createCoursesArrayId, this.errorRequest);
                requests.allBooksGroupByCourse(secretariatId, this.createListOfBooksById, this.errorRequest);
            },

            errorRequest(){
                var selected = this.$store.getters.selected;
                for (var i=0; i< selected.length;i++) {
                    if (selected[i].secretariatId == this.secretariatId) {
                        selected[i].message = this.$store.getters.errorMessageObject.message;
                    }
                }
                this.$store.commit('setSelected', selected);

                var linkedSemesterData = this.$store.getters.linkedSemesterData;
                if (linkedSemesterData.hasOwnProperty(this.secretariatId))
                    return;
                linkedSemesterData[this.secretariatId] = null;

                this.$store.commit('setLinkedSemesterData', linkedSemesterData);
            },

            createCoursesArrayId(response) {
                for (let i = 0; i < response.data.length; i++) {
                    this.coursesArrayId[i] = response.data[i].id;
                }

                this.courses = response.data;
                this.semesters = utils.getSemestersFromActive(response.data, this.$store.getters.login.statementMaxCourseSemester);
                requests.freebookCourses(this.coursesArrayId, this.createListOfEbooksById)
            },

            createListOfEbooksById(response) {

                var listLinkedEbooks = this.$store.getters.listLinkedEbooks;
                var finalObj = {};

                if (Object.keys(listLinkedEbooks).length > 0) {
                    for (var ebooksid in listLinkedEbooks) {
                        finalObj[ebooksid] = listLinkedEbooks[ebooksid]
                    }
                }
                if (Object.keys(response).length > 0 ) {
                    for (var id in response) {
                        finalObj[id] = response[id];
                    }
                }
                this.$store.commit('setListLinkedEbooks', finalObj);
            },

            createListOfBooksById(response) {
                this.listOfBooks = response;
                this.createListSemesterData();
            },

            createListSemesterData() {
                this.semesterCoursesArray = utils.createSemesterCoursesArray(this.courses, this.semesters);
                this.finalCoursesData()
            },

            finalCoursesData() {
                var linkedSemesterData = this.$store.getters.linkedSemesterData;
                var semesterData = utils.getSemesterData(this.listOfBooks, this.semesterCoursesArray, this.$store.getters.checkedBooks, this.selectedSecretariatId);
                linkedSemesterData[this.selectedSecretariatId] = semesterData;
                this.$store.commit('setLinkedSemesterData', linkedSemesterData);
                this.$store.commit('setLoadingModal', false);
                this.$forceUpdate();
            },

            addToArray(object) {
                this.checkedBooks[object.item.courseIno.id] = {
                    books: object.item.courseBooks[object.j],
                    period: object.item.courseBooks[object.j].course.period,
                    date: this.$store.getters.active.date
                };
                var redeemPoints = utils.redeemPointsById(this.checkedBooks, this.$store.getters.redeemPoints);
                this.$store.commit('setRedeemPoints', redeemPoints);
                this.$store.commit('setCheckedBooks', this.checkedBooks);

            },

            removeToArray(object) {
                delete this.checkedBooks[object.item.courseIno.id];
                this.$store.commit('setCheckedBooks', this.checkedBooks);
                this.$store.commit('setStatementBookGroup', null);
            },

            createFinalObject(){

                var webservicestatus  = this.$store.getters.login.academic.webservicestatus;
                var coursesCodes = [];
                var checkedBooks = this.$store.getters.checkedBooks;

                for (var checkedBook in checkedBooks) {
                    coursesCodes.push(checkedBook)
                }


                if (webservicestatus && coursesCodes.length > 0) {
                    this.$store.commit('setLoadingModal', true);
                    request.checkCourceRegistration(coursesCodes, this.successCheckCourceRegistration)
                }
                else {
                    this.$store.commit('setCourseRegistration' , []);
                    if(this.$store.getters.login.exchangeCredits > 0){
                        this.$router.push({path: '/redeemPoints'});
                    }
                    else {
                        this.$router.push({path: '/statementBookList'});
                    }
                }
            },

            successCheckCourceRegistration(response){

                var countCourses = 0;
                var message = {};
                message.warningTitle = 'Προσοχή!';
                message.warningMessage = ' Έχετε επιλέξει συγγράμματα για μαθήματα τα οποία δεν έχετε δηλώσει στη Γραμματεία της Σχολής σας. Τα παρακάτω μαθήματα θα πρέπει είτε να τα δηλώσετε στη Γραμματεία σας είτε να τα αποεπιλέξετε για να συνεχίσετε';
                // message.message += '<v-tooltipleft><template v-slot:activator="{ on }"><v-icon class="right" color="red" v-on="on">warning</v-icon></template><span>Δεν δικαιούστε το σύγγραμμα</span></v-tooltip>';
                message.close = true;
                if (response.length > 0 ){
                    message.warningList = '';
                    response.forEach(function (el) {
                        if (!el.registrationFound) {
                            if(el.courseDTO.code){
                                message.warningList += '<li><v-list-item><v-list-item-content><v-list-item-title>'+ '[' + el.courseDTO.code +']'  + ' '+ el.courseDTO.title +'</v-list-item-title></v-list-item-content></v-list-item>'
                            }else{
                                message.warningList += '<li><v-list-item><v-list-item-content><v-list-item-title>'+ el.courseDTO.title +  '</v-list-item-title></v-list-item-content></v-list-item>'
                            }
                            countCourses++;
                        }
                    });
                }
                if (countCourses > 0) {
                    this.$store.commit('setMessageObject', message);
                    this.$store.commit('setMessageModal', true);
                }
                else {
                    if(this.$store.getters.login.exchangeCredits > 0){
                        this.$router.push({path: '/redeemPoints'});
                    }
                    else {
                        this.$router.push({path: '/statementBookList'});
                    }
                }
                this.$store.commit('setLoadingModal', false);
            },
        }
    }
</script>

<style scoped>
    .editButton {
        font-size: small;
        padding-right: 5px;
    }
</style>
